import { CommandSendNotification } from "./commands/CmdSendNotification";

export class NotificationService {
    async send_notification(type: string, body: any) {
        const cmd = new CommandSendNotification()
        await cmd.run(type, body)
    }
}